<template>
  <el-autocomplete
    ref="el_auto"
    :key="keyCount"
    v-model="state"
    :size="size"
    :style="{width:width+'px'}"
    :fetch-suggestions="querySearchAsync"
    :placeholder="placeholder"
    :trigger-on-focus="false"
    :disabled="disabled"
    clearable
    @select="handleSelect"
    @clear="clearSelect"
    :popper-append-to-body="true"
    popper-class="modal-autocomplete-popper"
  />
</template>
<script>
import { queryUserData } from '@/api/userapi'

export default {
  name: "QueryUser",
  props: {
    clearQuery: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "mini"
    },
    width: {
      type: Number,
      default: 300
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请输入"
    }
  },
  data () {
    return {
      state: "",
      userId: "",
      keyCount: 0
    }
  },
  // 实时监听父组件传过来的值
  // 然后执行drawBar方法 重新绘制柱状图
  watch: {
    clearQuery (reset) {
      if (reset) {
        this.id = ""
        this.state = ''
        this.$emit("handle-select", "")
      }
    },
    state (val) {
      if (val == '') {
        this.clearSelect()
      }
    }
  },
  methods: {
    clearSelect () {
      this.state = ''
      this.$emit("handle-select", "")
      // 主要代码
      this.$refs.el_auto.activated = true
      this.keyCount++
    },
    setDefaultValue (uid) {
      if (uid == null || uid == '') {
        this.clearSelect()
        return
      }
      this.querySearchAsync(uid, item => {
        if (item && item.length > 0) {
          this.state = item[0].value
          this.keyCount++
        }
      })
    },
    async querySearchAsync (queryString, cb) {
      this.restaurants = []
      // 去空格
      queryString = queryString.trim()
      if (queryString) {
        const n = parseInt(queryString)
        if (!isNaN(n) && n < 10000) {
          cb(this.restaurants)
        } else {
          const _this = this
          this.$post(queryUserData, { queryKey: queryString }).then(da => {
            if (da.code == '00000') {
              if (da.data && da.data.length > 0) {
                da.data.forEach(item => {
                  _this.restaurants.push({ value: item.fullName + ', ID:' + item.id, userId: item.id })
                })
              }
              cb(_this.restaurants)
            } else {
              _this.$message.error(da.desc || '查询失败')
            }
          })
        }
      }
    },
    handleSelect (value) {
      this.$emit("handle-select", value.userId || '')
    }
  }
}
</script>
<style scoped>
.modal-autocomplete-popper {
  z-index: 9999 !important;
}
</style>
